import { RIFLE_TOURNAMENT_SLUG } from './shooting';

export const EVENT_SCORES_PATH = `/scoreboard/${RIFLE_TOURNAMENT_SLUG}`;
const EVENT_SCORES_URL = `https://app.smymchennai.in${EVENT_SCORES_PATH}`;

interface ScoresLinkEvent {
  slug: string;
  detailsUrl?: string | null;
  detailsLabel?: string | null;
}

/** Only this rifle event has an associated public results board. */
export function supportsEventScores(event: Pick<ScoresLinkEvent, 'slug'>): boolean {
  return event.slug === RIFLE_TOURNAMENT_SLUG;
}

/** Existing per-event details fields are the saved visibility setting. */
export function hasEventScoresLink(event: ScoresLinkEvent): boolean {
  const url = event.detailsUrl?.trim();
  return supportsEventScores(event) && (url === EVENT_SCORES_URL || url === EVENT_SCORES_PATH);
}

export function withEventScoresLink<T extends ScoresLinkEvent>(event: T, visible: boolean): T {
  if (!supportsEventScores(event)) return event;
  if (visible) return { ...event, detailsUrl: EVENT_SCORES_URL, detailsLabel: 'View scores' };
  if (!hasEventScoresLink(event)) return event;
  return { ...event, detailsUrl: '', detailsLabel: '' };
}
